/* ============================================================
   THE ABSOLUTE COLLAGEN — theme.js v2
   ============================================================ */

(function () {
  'use strict';

  /* ── OVERLAY A11Y — ESC to close, focus trap, focus restore ──
     Shared by the cart drawer, mobile nav, and filter drawer so keyboard /
     screen-reader users aren't trapped (was previously mouse-only). */
  let __overlayEl = null;
  let __overlayClose = null;
  let __overlayTrigger = null;
  function __focusables(el) {
    return Array.prototype.slice.call(el.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (n) { return n.offsetParent !== null; });
  }
  function activateOverlay(el, closeFn) {
    __overlayTrigger = document.activeElement;
    __overlayEl = el;
    __overlayClose = closeFn;
    var f = __focusables(el)[0];
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function deactivateOverlay() {
    __overlayEl = null; __overlayClose = null;
    if (__overlayTrigger && __overlayTrigger.focus) __overlayTrigger.focus();
    __overlayTrigger = null;
  }
  document.addEventListener('keydown', function (e) {
    if (!__overlayEl) return;
    if (e.key === 'Escape' && __overlayClose) { e.preventDefault(); __overlayClose(); return; }
    if (e.key === 'Tab') {
      var f = __focusables(__overlayEl);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ── STICKY HEADER ─────────────────────────────────────── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── MOBILE NAV ─────────────────────────────────────────── */
  const hamburger  = document.getElementById('hamburger');
  const mNav       = document.getElementById('m-nav');
  const closeNavBtns = document.querySelectorAll('[data-close-nav]');

  function openNav() {
    mNav && mNav.classList.add('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (mNav) activateOverlay(mNav, closeNav);
  }
  function closeNav() {
    mNav && mNav.classList.remove('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    deactivateOverlay();
  }

  if (hamburger) hamburger.addEventListener('click', openNav);
  closeNavBtns.forEach(btn => btn.addEventListener('click', closeNav));

  /* ── CART DRAWER ─────────────────────────────────────────── */
  const cartOpenBtn  = document.getElementById('cart-open-btn');
  const cartDrawer   = document.getElementById('cart-drawer');
  const cartOverlay  = document.getElementById('cart-drawer-overlay');
  const cartClose    = document.getElementById('cart-drawer-close');
  const cartBody     = document.getElementById('cart-drawer-body');
  const cartFoot     = document.getElementById('cart-drawer-foot');
  const cartSubtotal = document.getElementById('cart-drawer-subtotal');
  const cartTotal    = document.getElementById('cart-drawer-total');
  const cartCount    = document.getElementById('cart-drawer-count');
  const cartBadge    = document.getElementById('cart-badge');
  const cartSubNotice = document.getElementById('cart-drawer-sub-notice');

  function openCart() {
    cartDrawer  && cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (cartDrawer) activateOverlay(cartDrawer, closeCart);
    refreshCart();
  }
  function closeCart() {
    cartDrawer  && cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
    deactivateOverlay();
  }

  if (cartOpenBtn)  cartOpenBtn.addEventListener('click', openCart);
  if (cartClose)    cartClose.addEventListener('click', closeCart);
  if (cartOverlay)  cartOverlay.addEventListener('click', closeCart);

  /* ── PREDICTIVE SEARCH ───────────────────────────────────────
     Header magnifier opens a top overlay; typing fetches the
     `predictive-search` section (Section Rendering API) and injects it.
     Reuses the shared overlay a11y helper (ESC, focus trap, restore). */
  (function () {
    var searchOpenBtn = document.getElementById('search-open-btn');
    var searchOverlay = document.getElementById('search-overlay');
    var searchInput   = document.getElementById('search-input');
    var searchResults = document.getElementById('search-results');
    if (!searchOpenBtn || !searchOverlay || !searchInput || !searchResults) return;

    var MIN = 2;
    var debounceTimer = null;
    var lastController = null;
    var cache = {};

    function openSearch() {
      searchOverlay.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(function () { searchOverlay.classList.add('open'); });
      searchOpenBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      activateOverlay(searchOverlay, closeSearch);
      setTimeout(function () { searchInput.focus(); }, 70);
    }
    function closeSearch() {
      searchOverlay.classList.remove('open');
      searchOpenBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      deactivateOverlay();
      // wait out the CSS transition before hiding from a11y tree
      setTimeout(function () { if (!searchOverlay.classList.contains('open')) searchOverlay.hidden = true; }, 240);
    }

    searchOpenBtn.addEventListener('click', openSearch);
    searchOverlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    });

    function renderState(html) {
      searchResults.innerHTML = html;
      searchResults.classList.toggle('is-empty', html.trim() === '');
    }

    function runSearch(term) {
      if (cache[term]) { renderState(cache[term]); return; }
      if (lastController) lastController.abort();
      lastController = ('AbortController' in window) ? new AbortController() : null;
      searchResults.classList.add('is-loading');
      var url = '/search/suggest?q=' + encodeURIComponent(term) +
        '&section_id=predictive-search' +
        '&resources[type]=product,article,page,query' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url, lastController ? { signal: lastController.signal } : undefined)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          // Section Rendering API returns the bare section markup.
          cache[term] = html;
          searchResults.classList.remove('is-loading');
          renderState(html);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          searchResults.classList.remove('is-loading');
          renderState('<p class="psearch__empty">Search is unavailable right now.</p>');
        });
    }

    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(debounceTimer);
      if (term.length < MIN) {
        if (lastController) lastController.abort();
        searchResults.classList.remove('is-loading');
        renderState('');
        return;
      }
      debounceTimer = setTimeout(function () { runSearch(term); }, 220);
    });
  })();

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateBadge(cart.item_count);
        renderCartItems(cart);
      })
      .catch(console.error);
  }

  function updateBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count;
    cartBadge.classList.toggle('visible', count > 0);
  }

  function renderCartItems(cart) {
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (cartFoot) cartFoot.style.display = 'none';
      if (cartCount) cartCount.textContent = '';
      return;
    }
    if (cartFoot) cartFoot.style.display = 'block';
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
    if (cartCount) cartCount.textContent = '(' + cart.item_count + ')';
    if (cartSubNotice) cartSubNotice.hidden = !cart.items.some(i => i.selling_plan_allocation);

    // Shipping reassurance — free shipping on all U.S. orders (no threshold).
    // Copy can be overridden via data-ship-reassurance on the drawer element.
    var reassureText = (cartDrawer && cartDrawer.dataset.shipReassurance) || 'Free shipping on all U.S. orders';
    var reassure = '<div class="cart-reassure"><svg class="cart-reassure__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 13h11V6H3zM14 9h4l3 3v1h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg><p class="cart-reassure__label">' + reassureText + '</p></div>';

    cartBody.innerHTML = reassure + cart.items.map(item => {
      // Selling-plan (subscription) details and any active line-level discount
      // (e.g. the qty-tiered Automatic Discount) both come straight off the
      // real cart item — never re-derived or guessed client-side.
      var planName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';
      var lineDiscount = item.original_line_price - item.final_line_price;
      var discountTitle = (item.line_level_discount_allocations && item.line_level_discount_allocations[0])
        ? item.line_level_discount_allocations[0].discount_application.title
        : 'Discount';
      return `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__img">
          ${item.featured_image?.url
            ? `<img src="${item.featured_image.url}&width=240" alt="${item.title}" loading="lazy">`
            : ''}
        </div>
        <div class="cart-item__main">
          <div class="cart-item__row">
            <p class="cart-item__title">${item.product_title}</p>
            <p class="cart-item__line-price">${lineDiscount > 0 ? '<del>' + formatMoney(item.original_line_price) + '</del> ' : ''}${formatMoney(item.final_line_price)}</p>
          </div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          ${planName ? `<p class="cart-item__plan"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 21v-5h5"/></svg>Subscription · ${planName}</p>` : ''}
          ${lineDiscount > 0 ? `<p class="cart-item__discount">${discountTitle} · -${formatMoney(lineDiscount)}</p>` : ''}
          <div class="cart-item__controls">
            <div class="cart-item__qty">
              <button class="cart-item__qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">&#8722;</button>
              <span class="cart-item__qty-val">${item.quantity}</span>
              <button class="cart-item__qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button class="cart-item__remove" data-key="${item.key}" data-qty="0" type="button">Remove</button>
          </div>
        </div>
      </div>
    `;
    }).join('');

    // Qty change listeners
    cartBody.querySelectorAll('[data-qty]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        updateCartItem(key, qty);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(r => r.json())
      .then(cart => {
        updateBadge(cart.item_count);
        renderCartItems(cart);
      })
      .catch(console.error);
  }

  /* ── ADD TO CART ─────────────────────────────────────────── */
  function addToCart(variantId, btn, quantity, sellingPlan) {
    const qty = quantity && quantity > 0 ? quantity : 1;
    const originalHTML = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="spin"></span>';
    }
    const restore = () => { if (btn) { btn.disabled = false; btn.innerHTML = originalHTML; } };

    const payload = { id: variantId, quantity: qty };
    if (sellingPlan) payload.selling_plan = sellingPlan;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        restore();
        if (!ok) {
          // Surface Shopify's real error (e.g. inventory exceeded)
          showToast(data.description || data.message || 'Could not add to cart');
          return;
        }
        refreshCart();
        openCart();
        showToast('Added to cart');
      })
      .catch(err => {
        console.error(err);
        restore();
        showToast('Something went wrong');
      });
  }

  // Product card ATC buttons
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.dataset.addToCart, btn);
  });

  // Product page form
  const productForm = document.getElementById('product-form');
  if (productForm) {
    // The Ongoing Subscriptions @app block renders its own `selling_plan` field
    // inside this form (radio group, <select>, or a single hidden input
    // depending on plan count) — read whichever shape is present. An empty
    // value conventionally means "one-time purchase" selected.
    const getSellingPlan = form => {
      const checked = form.querySelector('[name="selling_plan"]:checked');
      if (checked) return checked.value || null;
      const single = form.querySelector('select[name="selling_plan"], input[name="selling_plan"]');
      return single && single.value ? single.value : null;
    };
    productForm.addEventListener('submit', e => {
      e.preventDefault();
      const variantInput = productForm.querySelector('#variant-id');
      if (!variantInput) return;
      const submitBtn = productForm.querySelector('#add-to-cart-btn');
      const qtyInput = productForm.querySelector('[name="quantity"]');
      const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      const sellingPlan = getSellingPlan(productForm);
      addToCart(variantInput.value, submitBtn, qty, sellingPlan);
    });
  }

  /* ── PRODUCT PAGE — GALLERY (swipe carousel) ─────────────── */
  (function () {
    const track = document.getElementById('pdp-gallery-track');
    if (!track) return;
    const slides = Array.from(track.children);
    const dots = Array.from(document.querySelectorAll('.pdp-gallery__dot'));
    if (slides.length <= 1) return;

    const indexFor = () => Math.round(track.scrollLeft / track.clientWidth);
    const sync = () => {
      const i = indexFor();
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    };
    let raf = null;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { sync(); raf = null; });
    }, { passive: true });

    dots.forEach((d, i) => d.addEventListener('click', () => {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }));
    const prev = document.querySelector('[data-gallery-prev]');
    const next = document.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
  }());

  /* ── PRODUCT PAGE — BUY BOX (size cards · subscribe/one-time · frequency ·
     qty pills · live order summary · variant/price · URL sync) ──
     Size cards select the matching variant; price, hidden variant id, ATC
     availability, and the sticky-bar price all live-update, and the ?variant=
     URL is kept in sync (shareable + back-button friendly).

     The subscribe-vs-one-time buy box here is fully independent of the
     Ongoing Subscriptions / Shopify Subscriptions @app block — it reads real
     selling_plan_allocations data serialized into #pdp-variants (see
     main-product.liquid) so price math is always Shopify's own computed
     numbers, never a discount % parsed out of a plan name. */
  (function () {
    const form = document.getElementById('product-form');
    if (!form) return;
    const variantInput = document.getElementById('variant-id');
    const priceEl = document.getElementById('product-price');
    const atcBtn = document.getElementById('add-to-cart-btn');
    const atcText = document.getElementById('atc-text');
    const stickyPrice = document.getElementById('pdp-sticky-price');
    const dataEl = document.getElementById('pdp-variants');
    let variants = [];
    let moneyFormat = '${{amount}}';
    let productTitle = '';
    try {
      const parsed = JSON.parse(dataEl.textContent);
      if (Array.isArray(parsed)) {
        variants = parsed;
      } else {
        variants = parsed.variants || [];
        moneyFormat = parsed.moneyFormat || moneyFormat;
        productTitle = parsed.productTitle || '';
      }
    } catch (e) { return; }

    // Classic Shopify money-format algorithm (condensed) — honors the shop's
    // real currency symbol/placement/decimal style from shop.money_format
    // instead of hardcoding "$".
    function formatMoney(cents) {
      cents = cents || 0;
      const match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      const kind = match ? match[1] : 'amount';
      const withComma = kind.indexOf('comma') !== -1;
      const noDecimals = kind.indexOf('no_decimals') !== -1;
      const precision = noDecimals ? 0 : 2;
      const thousands = withComma ? '.' : ',';
      const decimal = withComma ? ',' : '.';
      const amount = (cents / 100).toFixed(precision);
      const parts = amount.split('.');
      const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const value = parts[1] ? dollars + decimal + parts[1] : dollars;
      return match ? moneyFormat.replace(match[0], value) : ('$' + value);
    }

    const sizeBtns = Array.from(form.querySelectorAll('.pdp-size[data-option-index]'));
    const purchaseWrap = form.querySelector('[data-pdp-purchase]');
    const purchaseBtns = Array.from(form.querySelectorAll('[data-purchase-option]'));
    const frequencySelect = document.getElementById('pdp-frequency-select');
    const qtyPillBtns = Array.from(form.querySelectorAll('[data-qty-pill]'));
    const qtyInput = document.getElementById('pdp-qty-input');
    const qtyCustomInput = document.getElementById('pdp-qty-custom');
    const qtyBadges = Array.from(form.querySelectorAll('[data-qty-badge]'));
    const summaryWrap = form.querySelector('[data-pdp-summary]');
    const summaryProducts = document.getElementById('pdp-summary-products');
    const summaryToday = document.getElementById('pdp-summary-today');
    const summarySavings = document.getElementById('pdp-summary-savings');
    const summaryPromoNote = document.getElementById('pdp-summary-promo-note');
    const perDayEl = form.querySelector('[data-pdp-perday]');
    const servingsPerPackage = purchaseWrap ? (parseInt(purchaseWrap.dataset.servings, 10) || 30) : 30;
    // Labor Day first-month discount preview (Go Pack only, see main-product.liquid) —
    // only applies on the monthly cadence, and only while subscribing.
    const promoAmountCents = purchaseWrap ? (parseInt(purchaseWrap.dataset.promoAmount, 10) || 0) : 0;
    const promoNote = purchaseWrap ? (purchaseWrap.dataset.promoNote || '') : '';

    let purchaseOption = (purchaseWrap && purchaseWrap.dataset.hasSubscription === 'true') ? 'subscribe' : 'onetime';

    function selectedOptions() {
      const opts = [];
      sizeBtns.forEach(b => { if (b.classList.contains('is-active')) opts[+b.dataset.optionIndex] = b.dataset.value; });
      return opts;
    }
    function findVariant(opts) {
      if (!variants.length) return null;
      if (!opts.length) return variants[0];
      return variants.find(v => v.options.every((o, i) => opts[i] == null || o === opts[i])) || null;
    }
    function activate(optVals) {
      optVals.forEach((val, i) => {
        sizeBtns.forEach(b => {
          if (+b.dataset.optionIndex === i) {
            const match = b.dataset.value === val;
            b.classList.toggle('is-active', match);
            b.setAttribute('aria-checked', match ? 'true' : 'false');
          }
        });
      });
    }

    function qtyValue() {
      const n = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return n && n > 0 ? n : 1;
    }

    // The select only participates in the form (name="selling_plan") while
    // "Subscribe & save" is the active option — this is what makes the
    // existing getSellingPlan()/submit-handler logic naturally treat a
    // one-time selection as "no selling plan" without duplicating that logic.
    function applyPurchaseOptionToForm() {
      if (!frequencySelect) return;
      if (purchaseOption === 'subscribe') {
        frequencySelect.setAttribute('name', 'selling_plan');
      } else {
        frequencySelect.removeAttribute('name');
      }
    }

    function setPurchaseOption(opt) {
      purchaseOption = opt;
      purchaseBtns.forEach(b => {
        const active = b.dataset.purchaseOption === opt;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (summaryWrap) summaryWrap.hidden = opt !== 'subscribe';
      qtyBadges.forEach(b => { b.hidden = opt !== 'subscribe'; });
      applyPurchaseOptionToForm();
      updateSummary();
    }

    // The real discount lives in a Shopify Automatic Discount (2+ bags = 5%
    // off, 3+ bags = 12% off, subscription purchases only) — checkout always
    // computes the authoritative price. These tiers just mirror that config
    // so the buy box can preview savings before checkout.
    const QTY_DISCOUNT_TIERS = [
      { min: 3, pct: 12 },
      { min: 2, pct: 5 }
    ];
    function qtyDiscountPct(qty) {
      const tier = QTY_DISCOUNT_TIERS.find(t => qty >= t.min);
      return tier ? tier.pct : 0;
    }

    function updateSummary() {
      const v = findVariant(selectedOptions()) || variants[0];
      if (!v) return;
      const qty = qtyValue();
      if (summaryProducts) summaryProducts.textContent = qty + ' × ' + productTitle;

      const isSubscribe = purchaseOption === 'subscribe';
      const pct = isSubscribe ? qtyDiscountPct(qty) : 0;
      const unit = pct > 0 ? Math.round(v.price * (100 - pct) / 100) : v.price;
      let total = unit * qty;
      let compareTotal = pct > 0 ? v.price * qty : 0;

      const selectedIntervalCount = frequencySelect && frequencySelect.selectedOptions[0]
        ? parseInt(frequencySelect.selectedOptions[0].dataset.intervalCount, 10) : 0;
      const promoApplies = isSubscribe && promoAmountCents > 0 && selectedIntervalCount === 1;
      if (promoApplies) {
        if (compareTotal <= 0) compareTotal = total;
        total = Math.max(0, total - promoAmountCents);
      }

      if (summaryToday) {
        summaryToday.innerHTML = compareTotal > total
          ? '<del>' + formatMoney(compareTotal) + '</del> ' + formatMoney(total)
          : formatMoney(total);
      }
      if (summarySavings) {
        if (compareTotal > total) {
          summarySavings.hidden = false;
          summarySavings.textContent = 'You save ' + formatMoney(compareTotal - total);
        } else {
          summarySavings.hidden = true;
        }
      }
      if (summaryPromoNote) {
        summaryPromoNote.hidden = !promoApplies;
        if (promoApplies) summaryPromoNote.textContent = promoNote;
      }
      if (atcText) {
        if (!v.available) {
          atcText.textContent = 'Sold Out';
        } else {
          const label = isSubscribe ? 'Start My Subscription' : (atcText.dataset.label || 'Add to Cart');
          atcText.textContent = label + ' · ' + formatMoney(total);
        }
      }
      // Subscribe-card "$X/day" always reflects the subscribe-tier price,
      // regardless of which purchase option is currently active.
      if (perDayEl) {
        const subPct = qtyDiscountPct(qty);
        const subUnit = subPct > 0 ? Math.round(v.price * (100 - subPct) / 100) : v.price;
        perDayEl.textContent = 'As low as ' + formatMoney(Math.round(subUnit / servingsPerPackage)) + '/day';
      }
    }

    function render(updateUrl) {
      const v = findVariant(selectedOptions());
      if (!v) return;
      if (variantInput) variantInput.value = v.id;
      if (priceEl) {
        let html = '';
        if (v.compare_at && v.compare_at > v.price) html += '<del>' + v.compare_money + '</del> ';
        priceEl.innerHTML = html + v.price_money;
      }
      if (stickyPrice) stickyPrice.textContent = v.price_money;
      if (atcBtn) atcBtn.disabled = !v.available;
      updateSummary();
      if (updateUrl && variants.length > 1 && window.history && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    sizeBtns.forEach(b => {
      b.addEventListener('click', () => {
        const idx = b.dataset.optionIndex;
        sizeBtns.forEach(o => { if (o.dataset.optionIndex === idx) { o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false'); } });
        b.classList.add('is-active');
        b.setAttribute('aria-checked', 'true');
        render(true);
      });
    });

    purchaseBtns.forEach(b => {
      // The subscribe card is a div[role=button] (a <select> can't legally nest inside
      // a real <button>), so it needs its own keydown handling for Enter/Space — native
      // <button> elements already get that for free and are left alone here.
      b.addEventListener('click', e => {
        if (e.target.closest('select')) return;
        setPurchaseOption(b.dataset.purchaseOption);
      });
      if (b.getAttribute('role') === 'button') {
        b.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setPurchaseOption(b.dataset.purchaseOption);
          }
        });
      }
    });
    if (frequencySelect) frequencySelect.addEventListener('change', updateSummary);

    // Presets (1/2/3) and the custom qty box are mutually exclusive: picking a
    // preset clears the custom box, typing a custom value clears the presets.
    // The hidden #pdp-qty-input (name="quantity") is the one real source of
    // truth submitted to the cart — the visible custom box never carries
    // that name, so it never redundantly mirrors whatever preset is active.
    qtyPillBtns.forEach(b => b.addEventListener('click', () => {
      qtyPillBtns.forEach(o => { o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false'); });
      b.classList.add('is-active');
      b.setAttribute('aria-pressed', 'true');
      if (qtyInput) qtyInput.value = b.dataset.qtyPill;
      if (qtyCustomInput) qtyCustomInput.value = '';
      updateSummary();
    }));
    if (qtyCustomInput) {
      qtyCustomInput.addEventListener('input', () => {
        const n = parseInt(qtyCustomInput.value, 10);
        qtyPillBtns.forEach(b => { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        if (qtyInput && n > 0) qtyInput.value = n;
        updateSummary();
      });
    }

    applyPurchaseOptionToForm();

    // Pre-select from ?variant= on load (deep links / back button)
    const urlVariantId = new URL(window.location.href).searchParams.get('variant');
    if (urlVariantId) {
      const v = variants.find(x => String(x.id) === String(urlVariantId));
      if (v && sizeBtns.length) activate(v.options);
    }
    render(false);
  }());

  /* ── PRODUCT PAGE — STICKY ADD-TO-CART (mobile) ──────────── */
  (function () {
    const bar = document.querySelector('[data-pdp-sticky]');
    const atc = document.getElementById('add-to-cart-btn');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => bar.classList.toggle('is-visible', !e.isIntersecting));
    }, { rootMargin: '0px 0px -8px 0px' });
    io.observe(atc);
  }());

  /* ── ACCORDION ───────────────────────────────────────────── */
  document.querySelectorAll('.accordion-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
      document.querySelectorAll('.accordion-btn').forEach(b => b.setAttribute('aria-expanded', 'false'));
      // Open clicked (if it wasn't open)
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── ANNOUNCEMENT BAR ROTATION ───────────────────────────── */
  const annItems = document.querySelectorAll('.ann-bar__item');
  if (annItems.length > 1) {
    let current = 0;
    annItems.forEach((item, i) => { item.style.display = i === 0 ? '' : 'none'; });
    setInterval(() => {
      annItems[current].style.display = 'none';
      current = (current + 1) % annItems.length;
      annItems[current].style.display = '';
    }, 4000);
  }

  /* ── NEWSLETTER FORM ─────────────────────────────────────── */
  const newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', e => {
      const btn = newsletterForm.querySelector('[type="submit"]');
      if (btn) btn.textContent = 'Subscribing...';
    });
  }

  /* ── TOAST ───────────────────────────────────────────────── */
  const toast = document.getElementById('toast');
  let toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 3000);
  }

  /* ── SCROLL REVEAL ───────────────────────────────────────── */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('revealed'));
  }

  /* ── CART PAGE — QTY + REMOVE ───────────────────────────── */
  document.addEventListener('click', e => {
    // Cart page qty
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const key    = qtyBtn.dataset.qtyChange;
      const change = parseInt(qtyBtn.dataset.change, 10);
      const valEl  = document.getElementById('qty-' + key);
      if (!valEl) return;
      const newQty = Math.max(0, parseInt(valEl.textContent, 10) + change);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(r => r.json()).then(() => location.reload());
    }

    // Cart page remove
    const removeBtn = e.target.closest('[data-remove-key]');
    if (removeBtn) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: removeBtn.dataset.removeKey, quantity: 0 })
      }).then(() => location.reload());
    }
  });

  /* ── COLLECTION (PLP) — sort ─────────────────────────────── */
  (function () {
    const sort = document.querySelector('[data-sort]');
    if (!sort) return;
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }());

  /* ── TESTIMONIALS CAROUSEL ───────────────────────────── */
  document.querySelectorAll('[data-testimonials-carousel]').forEach(carousel => {
    const track   = carousel.querySelector('[data-carousel-track]');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    if (!track || !prevBtn || !nextBtn) return;

    const cards = track.querySelectorAll('.testi-card');
    if (cards.length === 0) return;

    function perPage() {
      if (window.innerWidth <= 860) return 1;
      return 3;
    }
    let page = 0;

    function pageCount() { return Math.max(1, Math.ceil(cards.length / perPage())); }

    function applyTransform() {
      const viewport = carousel.querySelector('[data-carousel-viewport]');
      if (!viewport) return;
      const offset = page * viewport.clientWidth;
      track.style.transform = `translateX(-${offset}px)`;
      prevBtn.disabled = page === 0;
      nextBtn.disabled = page >= pageCount() - 1;
    }

    prevBtn.addEventListener('click', () => { if (page > 0) { page--; applyTransform(); } });
    nextBtn.addEventListener('click', () => { if (page < pageCount() - 1) { page++; applyTransform(); } });
    window.addEventListener('resize', () => { page = 0; applyTransform(); }, { passive: true });
    applyTransform();
  });

  /* ── RECENTLY VIEWED ─────────────────────────────────────────
     Records the current product handle in localStorage and renders
     previously-viewed products via the Section Rendering API
     (recently-viewed-card), reusing the product-card markup. */
  (function () {
    var box = document.querySelector('[data-recently-viewed]');
    if (!box) return;
    var KEY = 'ac:recently-viewed';
    var current = box.getAttribute('data-current-handle');
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 4;
    var grid = box.querySelector('[data-recently-viewed-grid]');

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    var stored = read().filter(function (h) { return h && h !== current; });

    // Record current handle at the front (cap history at 12).
    if (current) {
      write([current].concat(stored).slice(0, 12));
    }
    if (!grid || stored.length === 0) return;

    var handles = stored.slice(0, limit);
    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '?section_id=recently-viewed-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      var added = 0;
      htmls.forEach(function (html) {
        var markup = (html || '').trim();
        if (!markup) return;
        var wrap = document.createElement('div');
        wrap.innerHTML = markup;
        var card = wrap.querySelector('.product-card') || wrap.firstElementChild;
        if (card) { grid.appendChild(card); added++; }
      });
      if (added > 0) box.hidden = false;
    });
  })();

  // Initial badge load
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateBadge(cart.item_count))
    .catch(() => {});

})();
